var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.5 7L0.870835 0.25L12.1292 0.250001L6.5 7Z","fill":"currentColor"}));
}

Triangle.defaultProps = {"fill":"currentColor","width":"13","height":"7","viewBox":"0 0 13 7"};

module.exports = Triangle;

Triangle.default = Triangle;
